import React from 'react';
import cn from 'classnames';
import {
  REMUNERATIONS_LIST_TABLE_TOOLTIP_MAP,
  REMUNERATIONS_LIST_TABLE_VALUE_MAP,
  TradeCPTsTableMap,
} from '@/creditflowresearch/ui/components/trace/contants';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';
import { OTHER_SECTOR } from '@/creditflowresearch/domain/Sector';
import { TableSectorTooltip } from '@/creditflowresearch/ui/common/components/TableCells';

import styles from '../trace.module.scss';

export const getBaseCell = ({ cellData }) => cellData || '-';

export const getNumberWithDecimalsCell = ({ cellData }, decimals) => {
  return cellData
    ? formatNumberWithDecimals(cellData, decimals)
    : '-';
};

export const getTradeStringSizeCell = ({ cellData }) => {
  if (cellData) {
    return Number(cellData) ? formatNumberWithDecimals(cellData, 0) : cellData;
  }
  return '-';
};

export const getReportingPartySideCell = ({ cellData }) => (
  <span className={ cn({
    [styles.partySideCellBuy]: cellData === 'Buy',
    [styles.partySideCellSell]: cellData === 'Sell',
  }) }
  >{ cellData || '-' }
  </span>
);

export const getRNUMCell = ({ cellData }) => (
  <Tooltip content={ REMUNERATIONS_LIST_TABLE_TOOLTIP_MAP[cellData] }>
    { REMUNERATIONS_LIST_TABLE_VALUE_MAP[cellData] }
  </Tooltip>
);

export const getCPTCell = ({ cellData }) => TradeCPTsTableMap[cellData] || '-';

export const getSectorCell = ({ row }) => {
  const sector = row?.sector || OTHER_SECTOR;
  const subsectorName = row?.subsector?.name;
  const tooltip = subsectorName ? `${ sector.name }: ${ subsectorName }` : sector.name;

  return (
    <TableSectorTooltip sector={ sector } tooltip={ tooltip } />
  );
};
